<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ChannelIcon from 'dashboard/components-next/icon/ChannelIcon.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  channel: { type: Object, required: true },
  connectedInbox: { type: Object, default: null },
});

defineEmits(['connect']);

const { t } = useI18n();

const connected = computed(() => Boolean(props.connectedInbox));
// Prefer the real connected account's name over the detected handle — the user
// may have connected a different account than the one we detected.
const connectedName = computed(
  () =>
    props.connectedInbox?.name ||
    props.channel.handle ||
    t(props.channel.labelKey)
);
</script>

<template>
  <div class="flex items-center gap-2 p-3 border-b border-polaris-border">
    <div class="size-4 rounded overflow-hidden flex-shrink-0">
      <ChannelIcon
        :inbox="channel.inbox"
        use-brand-icon
        class="size-4"
        :class="{ grayscale: !connected }"
      />
    </div>
    <span
      class="flex-1 min-w-0 truncate type-polaris-body text-polaris-foreground"
    >
      {{ t(channel.labelKey) }}
    </span>
    <div
      v-if="connected"
      class="flex items-center gap-2 flex-shrink-0 type-polaris-body text-polaris-muted-foreground"
    >
      <span class="whitespace-nowrap">{{ connectedName }}</span>
      <span class="w-px h-3 bg-polaris-border" />
      <span class="whitespace-nowrap">
        {{ t('ONBOARDING_INBOX_SETUP.CHANNELS.CONNECTED') }}
      </span>
    </div>
    <NextButton
      v-else
      type="button"
      variant="outline"
      color="slate"
      size="sm"
      class="flex-shrink-0"
      :label="t('ONBOARDING_INBOX_SETUP.CHANNELS.CONNECT')"
      @click="$emit('connect', channel)"
    />
  </div>
</template>
